export const en = {
    Errors: {
        loadFailed: "We couldn't load the skills.",
        reassurance: "Nothing is lost. Try again in a moment.",
        retry: "Try again",
        refreshBanner: "We couldn't refresh the list. Showing the previous results."
    },
    SkillGrid: {
        searchPlaceholder: "Search skills",
        searchAriaLabel: "Search skills",
        featureFilter: "Feature",
        featureFilterSelected_one: "{{count}} feature",
        featureFilterSelected_other: "{{count}} features",
        featureFilterAriaLabel: "Filter by feature",
        clearFeatureFilter: "Clear filter",
        clearAllFilters: "Clear all filters",
        resultCount_one: "{{count}} skill",
        resultCount_other: "{{count}} skills",
        resultCountFiltered_one: "{{count}} of {{total}} skill",
        resultCountFiltered_other: "{{count}} of {{total}} skills",
        noResults: "No skills match your filters.",
        noResultsHint: "Try a different search, or clear a filter.",
        noSkillsYet: "No skills yet.",
        comingSoon: "Coming soon"
    },
    SkillNotFound: {
        heading: "Skill not found",
        body: "This skill doesn't exist or isn't available.",
        backToSkills: "Back to Skills"
    },
    SkillTemplateByline: {
        workleap: "Workleap",
        you: "You",
        organizationFallback: "Your organization"
    },
    SkillTemplateViewer: {
        viewOnly: "View only",
        editCopy: "Edit a copy",
        contentLabel: "Agent instructions"
    },
    SkillTryItNowButton: {
        label: "Try it out"
    }
};
